import { c as _c } from "react/compiler-runtime";
import { HotelReserveCardCancellationModal } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-cancellation-modal";
import { HotelReservedCardContentPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-content/hotel-reserved-card-content.types";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import { numberConvert } from "@website/utils/number-convert";
import isBoolean from "lodash-es/isBoolean";
import isEmpty from "lodash-es/isEmpty";
import { useRouter } from "next/router";
import { useState } from "react";
export const HotelReserveCardContent = properties => {
  const $ = _c(63);
  const {
    id,
    title,
    availableRooms,
    rackIncluded,
    extraBed,
    hasBreakfast,
    adults,
    facilities,
    onClick,
    description,
    hasMorContentButton: t0,
    freeCancellation,
    cancellationPolicies,
    regularBadges,
    roomCount
  } = properties;
  const hasMorContentButton = t0 === undefined ? true : t0;
  const router = useRouter();
  const isFull = !availableRooms && !rackIncluded;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== cancellationPolicies || $[2] !== open) {
    t2 = {
      open,
      onClose: t1,
      cancellationPolicies
    };
    $[1] = cancellationPolicies;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const modalProperties = t2;
  let t3;
  if ($[4] !== availableRooms || $[5] !== facilities?.length || $[6] !== hasMorContentButton || $[7] !== id || $[8] !== isFull || $[9] !== onClick || $[10] !== roomCount) {
    t3 = isMobile => {
      if (hasMorContentButton) {
        return <div className={`text-body-2 text-secondary cursor-pointer flex-row gap-1 ${isMobile ? "flex lg:hidden" : "hidden lg:flex"}`} onClick={() => onClick?.({
          roomId: id,
          tabSelected: facilities?.length && availableRooms ? "facilities" : "roomCalendar",
          availableRooms,
          noRooms: roomCount
        })}><span className="whitespace-nowrap">جزئیات{isFull ? "" : " \u0648 \u0642\u0648\u0627\u0646\u06CC\u0646 \u06A9\u0646\u0633\u0644\u06CC"}</span><MaterialIcon name="arrow_back_ios" className="text-xs" /></div>;
      }
    };
    $[4] = availableRooms;
    $[5] = facilities?.length;
    $[6] = hasMorContentButton;
    $[7] = id;
    $[8] = isFull;
    $[9] = onClick;
    $[10] = roomCount;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const moreContentButton = t3;
  let t4;
  if ($[12] !== isFull) {
    t4 = isFull && <MiniChips color="error" text={"\u0638\u0631\u0641\u06CC\u062A \u062A\u06A9\u0645\u06CC\u0644"} variant="round-contained" />;
    $[12] = isFull;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== title) {
    t5 = <h3 className="text-on-surface-high-emphasis text-subtitle-2 lg:text-subtitle-1">{title}</h3>;
    $[14] = title;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <div className="flex flex-col gap-2 lg:flex-row lg:items-center">{t4}{t5}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== moreContentButton) {
    t7 = moreContentButton(false);
    $[19] = moreContentButton;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <div className="flex flex-row justify-between gap-2">{t6}{t7}</div>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <MaterialIcon name="person" />;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== adults || $[26] !== router.locale) {
    t10 = numberConvert(adults, {
      locale: router.locale
    });
    $[25] = adults;
    $[26] = router.locale;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const t11 = `${t10} نفر`;
  let t12;
  if ($[28] !== t11) {
    t12 = <MiniChips StartIcon={t9} text={t11} variant="accent" />;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== hasBreakfast) {
    t13 = Boolean(hasBreakfast) && <MiniChips StartIcon={<MaterialIcon name="local_cafe" />} text={"\u0628\u0627 \u0635\u0628\u062D\u0627\u0646\u0647"} variant="accent" />;
    $[30] = hasBreakfast;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== extraBed) {
    t14 = Boolean(extraBed) && <MiniChips StartIcon={<MaterialIcon name="hotel" />} text={"\u0642\u0627\u0628\u0644\u06CC\u062A \u062A\u062E\u062A \u0627\u0636\u0627\u0641\u0647"} variant="accent" />;
    $[32] = extraBed;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== rackIncluded) {
    t15 = Boolean(rackIncluded) && <MiniChips StartIcon={<MaterialIcon name="event" />} color="error" text={"\u0628\u0627\u0632\u0647 \u0627\u0642\u0627\u0645\u062A\u06CC \u0645\u0634\u062E\u0635 "} variant="accent" />;
    $[34] = rackIncluded;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== cancellationPolicies || $[37] !== freeCancellation) {
    t16 = isBoolean(freeCancellation) && (freeCancellation ? isEmpty(cancellationPolicies) ? <MiniChips StartIcon={<MaterialIcon name="check" />} color="success" text={"\u06A9\u0646\u0633\u0644\u06CC \u0631\u0627\u06CC\u06AF\u0627\u0646"} variant="accent" /> : <MiniChips className="cursor-pointer" color="secondary" onClick={() => setOpen(true)} text={"\u0642\u0648\u0627\u0646\u06CC\u0646 \u06A9\u0646\u0633\u0644\u06CC"} variant="text" /> : <MiniChips StartIcon={<MaterialIcon name="do_not_disturb" variant="outlined" />} color="error" text={"\u063A\u06CC\u0631\u0642\u0627\u0628\u0644 \u0627\u0633\u062A\u0631\u062F\u0627\u062F"} variant="accent" />);
    $[36] = cancellationPolicies;
    $[37] = freeCancellation;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t12 || $[40] !== t13 || $[41] !== t14 || $[42] !== t15 || $[43] !== t16) {
    t17 = <div className="flex w-full flex-row flex-wrap gap-1">{t12}{t13}{t14}{t15}{t16}</div>;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== regularBadges) {
    t18 = regularBadges?.map(_temp);
    $[45] = regularBadges;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== description || $[48] !== router.locale) {
    t19 = Boolean(description) && <span className="text-caption text-on-surface-medium-emphasis flex items-center gap-2 text-justify"><MaterialIcon className="!overflow-clip text-lg" name="bed" variant="outlined" />{numberConvert(description, {
        locale: router.locale
      })}</span>;
    $[47] = description;
    $[48] = router.locale;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== moreContentButton) {
    t20 = moreContentButton(true);
    $[50] = moreContentButton;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== t17 || $[53] !== t18 || $[54] !== t19 || $[55] !== t20 || $[56] !== t8) {
    t21 = <div className="flex flex-col gap-4 p-4">{t8}{t17}{t18}{t19}{t20}</div>;
    $[52] = t17;
    $[53] = t18;
    $[54] = t19;
    $[55] = t20;
    $[56] = t8;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== modalProperties) {
    t22 = <HotelReserveCardCancellationModal {...modalProperties} />;
    $[58] = modalProperties;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== t21 || $[61] !== t22) {
    t23 = <div className="flex flex-col">{t21}{t22}</div>;
    $[60] = t21;
    $[61] = t22;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  return t23;
};
function _temp(t0) {
  const {
    color,
    icon,
    text,
    transparent
  } = t0;
  return <span className="relative flex h-6 w-fit items-center gap-[6px] whitespace-nowrap rounded-[4px] px-[7px] outline-none" key={text} style={{
    color: transparent ? color : "white",
    backgroundColor: transparent ? `${color}20` : color
  }}>{icon && <span className="text-sm"><MaterialIcon name={icon} variant="outlined" /></span>}<span className="text-caption">{text}</span></span>;
}